export default "__VITE_ASSET__bd6d8601__"